import {AddCardForm} from 'attendee/Billing/AddCardForm'
import {PaymentMethods} from 'attendee/Billing/PaymentMethods'
import {useAttendeeBilling} from 'attendee/Billing/Providers/AttendeeBillingProvider'
import {Loader} from 'attendee/theme/Loader'
import {useI18n} from 'i18n/I18nContext'
import React, {useEffect, useState} from 'react'

export function Pay() {
  const {t} = useI18n()
  const {paymentMethods, getPaymentMethods, selectPaymentMethod, loading} =
    useAttendeeBilling()
  const [showAddForm, setShowAddForm] = useState<boolean>(false)

  useEffect(() => {
    getPaymentMethods()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (loading) {
    return <Loader />
  }

  return (
    <div>
      {paymentMethods.length > 0 && (
        <>
          <span style={{fontSize: 13, fontStyle: 'italic', fontWeight: 'bold'}}>
            * {t('orgBilling.payInvoiceHint')}
          </span>
          <PaymentMethods
            onSelect={selectPaymentMethod}
            selectLabel={t('orgBilling.selectPayment')}
          />
        </>
      )}
      {(showAddForm || paymentMethods.length <= 0) && <AddCardForm />}
      {!showAddForm && paymentMethods.length > 0 && (
        <button
          className="element__btn red-bg w-100 text-center mt-15"
          onClick={() => {
            setShowAddForm(true)
          }}
        >
          {t('orgBilling.addAnotherPaymentMethod')}{' '}
          <i className="fa-regular fa-angle-right"></i>
        </button>
      )}
    </div>
  )
}
